<template>
  <div class="receptionist-container">
    <div class="rc-row">
      <div class="rc-login">
        <div class="wrap-login">
          <div class="item event-name">
            <h2>
              {{ m_event.event_name }}
            </h2>
          </div>

          <div class="language-widget">
            <span>{{
              $t('login-receptionist-page.language', {
                split: '/'
              })
            }}</span>
            <span
              v-for="(item, index) in dataLanguage"
              :key="index"
              :class="langCodeCurrent == item.key && 'lang-active'"
              v-on:click="changeLanguage(item.lang_code, item.lang_name)"
            >
              <a>{{ item.lang_name }}</a>
            </span>
          </div>

          <div class="item rc-header">
            <h2>
              {{
                $t('login-receptionist-page.login-header', {
                  split: '/'
                })
              }}
            </h2>
          </div>

          <v-form
            class="form mt-3"
            ref="form"
            v-model="valid"
            :v-bind="true"
            v-on:submit.prevent="handleSubmit"
          >
            <div class="item">
              <label>{{ $t('login-page.label-email', { split: '/' }) }}</label>
              <v-text-field
                v-model.trim="$v.email.$model"
                outlined
                dense
                class="mt-1 input-login"
                hide-details="true"
              ></v-text-field>
              <div
                class="error-input"
                v-if="
                  $v.email.$invalid && $v.email.$dirty && !$v.email.required
                "
              >
                {{
                  $t('login-page.validate.email-required', {
                    split: '/'
                  })
                }}
              </div>
            </div>

            <div class="item mt-4">
              <label>{{
                $t('login-page.label-password', {
                  split: '/'
                })
              }}</label>
              <v-text-field
                v-model.trim="$v.password.$model"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                @click:append="show1 = !show1"
                outlined
                dense
                @keydown.space.prevent
                class="mt-1 input-login"
                hide-details="true"
              ></v-text-field>

              <div
                class="error-input"
                v-if="
                  $v.password.$invalid &&
                  $v.password.$dirty &&
                  !$v.password.required
                "
              >
                {{
                  $t('login-page.validate.password-required', {
                    split: '/'
                  })
                }}
              </div>
            </div>

            <div class="item text-center mt-4">
              <v-btn
                class="login-btn"
                color="#E8320D"
                v-on:click="handleSubmit"
                >{{
                  $t('login-page.btn-login', {
                    split: '/'
                  })
                }}</v-btn
              >
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import './login.scss';

import { mapGetters } from 'vuex';
import {
  LANG_CODE_JAPANESE,
  LANG_CODE_VIETNAMESE,
  UN_DISPLAY,
  DISPLAY
} from '@/common/constants';

export default {
  name: 'login',
  components: {},
  data: () => ({
    valid: true,
    email: '',
    password: '',
    show1: false,
    urlCode: ''
  }),

  validations: {
    email: {
      required
    },
    password: {
      required
    }
  },

  methods: {
    handleSubmit() {
      this.$v.$touch();
      const data = {
        mail_address: this.email,
        password: this.password,
        event_id: this.$store.state.checkEvent.event_id,
        contract_id: this.$store.state.eventMaster.m_event.contract_id
      };

      if (!this.$v.$error) {
        this.$store.dispatch('loginReceptionist', { data }).then((res) => {
          if (res === true) {
            this.$router.push(this.pathDefault + '/me', () => {});
          }
        });
      }
    },

    convertDateAndTime(datetime) {
      const date = new Date(datetime.replace(/\s/, 'T'));
      let dateString = '';

      let stringTime = '';
      let hours = '';
      let minutes = '';
      let seconds = '';

      hours =
        date.getHours().toString().length < 2
          ? '0' + date.getHours()
          : date.getHours();

      minutes =
        date.getMinutes().toString().length < 2
          ? '0' + date.getMinutes()
          : date.getMinutes();

      seconds =
        date.getSeconds().toString().length < 2
          ? '0' + date.getSeconds()
          : date.getSeconds();

      stringTime = `${hours}:${minutes}:${seconds}`;

      if (this.$i18n.locale === LANG_CODE_JAPANESE) {
        dateString =
          date.getFullYear() +
          '-' +
          (parseInt(date.getMonth()) + 1) +
          '-' +
          date.getDate() +
          ' ' +
          stringTime;
      } else {
        dateString =
          date.getDate() +
          '-' +
          (parseInt(date.getMonth()) + 1) +
          '-' +
          date.getFullYear() +
          ' ' +
          stringTime;
      }

      return dateString;
    },

    displayEventPeriod() {
      let stringDateTime = '';
      if (this.m_event !== null) {
        stringDateTime =
          this.convertDateAndTime(this.m_event.event_period_from) +
          ' ~ ' +
          this.convertDateAndTime(this.m_event.event_period_to);
      }

      return stringDateTime;
    },

    checkDisplayHr() {
      if (this.m_event !== null) {
        const {
          organizer_name_display,
          cooperator_display,
          sponsor_display,
          operator_display
        } = this.m_event;

        if (
          sponsor_display === this.UN_DISPLAY &&
          operator_display === this.UN_DISPLAY &&
          organizer_name_display === this.UN_DISPLAY &&
          cooperator_display === this.UN_DISPLAY
        ) {
          return false;
        }
      }
      return true;
    },

    checkDisplayContactTo() {
      if (this.m_event !== null) {
        const {
          contact_to_display,
          contact_mail_display,
          contact_phone_display,
          contact_address_display
        } = this.m_event;

        if (
          contact_to_display === this.UN_DISPLAY &&
          contact_mail_display === this.UN_DISPLAY &&
          contact_phone_display === this.UN_DISPLAY &&
          contact_address_display === this.UN_DISPLAY
        ) {
          return false;
        }
      }
      return true;
    }
  },

  watch: {
    'checkAuth.isAuthenticated': function (val) {
      if (val === true) {
        this.$router.push(this.pathDefault + '/me', () => {});
      }
    },

    '$i18n.locale': function (val) {
      this.langCodeCurrent =
        val === LANG_CODE_JAPANESE ? LANG_CODE_JAPANESE : LANG_CODE_VIETNAMESE;

      return val;
    }
  },

  computed: {
    ...mapGetters({
      registrationPeriodStatus: 'getRegistrationPeriodStatus',
      m_event: 'getEventData',
      status: 'getStatusCheckEvent',
      checkAuth: 'getStatusCheckAuthReceptionist'
    })
  },

  created() {
    this.DISPLAY = DISPLAY;
    this.UN_DISPLAY = UN_DISPLAY;

    if (typeof this.$i18n.locale !== 'undefined') {
      const lang = this.$i18n.locale;

      this.langCodeCurrent =
        lang === LANG_CODE_JAPANESE ? LANG_CODE_JAPANESE : LANG_CODE_VIETNAMESE;
    }
  }
};
</script>
<style lang="scss"></style>
